
import React from 'react';
import RouteFiles from './RouteFiles'
import './App.css' 
import '@fortawesome/fontawesome-free/css/all.min.css';


const App = () => {
  return (
    
  <>
  <RouteFiles/>
 
  </>
  );
};


export default App;

